import { render, staticRenderFns } from "./AccidentIncidentEventChart.vue?vue&type=template&id=627df1b2&"
import script from "./AccidentIncidentEventChart.vue?vue&type=script&lang=js&"
export * from "./AccidentIncidentEventChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports